// Unpublished Work © 2025 Deere & Company.

import {getInitialProps} from './initialize.ts';
import {renderApp, renderLandingPage} from './render.tsx';

getInitialProps()
    .then((initialProps) => {
        if (initialProps?.session?.hasToken) {
            renderApp(initialProps);
        } else if (initialProps) {
            renderLandingPage(initialProps);
        } else {
            throw new Error('Page failed to load');
        }
    })
    .catch(() => {
        // catch errors silently
    });
